import { useEffect, useRef } from 'react';
import noUiSlider from 'nouislider';
import { useLocation } from 'react-router-dom';
import { numberConverter } from '../../dictionary';

const sliderMinValue = 0
const sliderMaxValue = 75000

const Tuition = ({ tuitionMin, tuitionMax, setTuitionMin, setTuitionMax, setTuitionParams, resetStateToggle }) => {

  const location = useLocation();
  const tuitionSliderRef: any = useRef(null);
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (tuitionSliderRef.current && tuitionSliderRef.current.noUiSlider) {
      tuitionSliderRef.current.noUiSlider.set([tuitionMin, tuitionMax]);
    }
  }, [tuitionMin, tuitionMax]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setTuitionMin(sliderMinValue);
    setTuitionMax(sliderMaxValue);

    if (tuitionSliderRef.current && tuitionSliderRef.current.noUiSlider) {
      tuitionSliderRef.current.noUiSlider.set([sliderMinValue, sliderMaxValue]);
    }
  }, [resetStateToggle]);

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let tuitionParam = params.get('tuition');

    if (tuitionParam) {
      const tuitionVals = tuitionParam.split(',').map(tuition => parseInt(tuition));
      setTuitionMin(tuitionVals[0]);
      setTuitionMax(tuitionVals[1]);
    } else {
      setTuitionMin(sliderMinValue);
      setTuitionMax(sliderMaxValue);
    }
  }, [location.search, setTuitionMin, setTuitionMax]);

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let minMaxArr: any = [];

    if (tuitionMin !== 0 || tuitionMax !== 100) {
      minMaxArr = [tuitionMin, tuitionMax];
      const minMax = minMaxArr.join(',');
      params.set('tuition', minMax);
    } else {
      params.delete('tuition');
    }

    setTuitionParams(params.toString());
  }, [tuitionMin, tuitionMax, location.search, setTuitionParams]);

  useEffect(() => {
    const sliderElement: any = document.querySelector("#kt_slider_tuition");

    if (sliderElement && !sliderElement.noUiSlider) {

      let params = new URLSearchParams(location.search);
      let tuitionParam = params.get('tuition');
      const startValues = tuitionParam ? tuitionParam.split(',').map(tuition => parseInt(tuition)) : [sliderMinValue, sliderMaxValue];

      noUiSlider.create(sliderElement, {
        start: startValues,
        step: 500,
        range: {
          min: sliderMinValue,
          max: sliderMaxValue,
        },
        tooltips: {
          to: function (value) {
            return `$${numberConverter(parseInt(value.toFixed(0)))}`;
          },
        },
      });

      sliderElement.noUiSlider.on("set", (values, handle) => {
        if (handle === 0) {
          setTuitionMin(parseInt(values[0]));
        }
        if (handle === 1) {
          setTuitionMax(parseInt(values[1]));
        }
      });

      tuitionSliderRef.current = sliderElement;
    }

    return () => {
      if (sliderElement && sliderElement.noUiSlider) {
        sliderElement.noUiSlider.destroy();
      }
    };
  }, [location.search, setTuitionMin, setTuitionMax]);

  return (
    <div className='mt-4 d-flex flex-column' style={{ marginTop: '15px' }}>
      <div className='dca-aside-header'>TUITION</div>
      <div className="mb-0" id='dca-college-search-tuition-mobile' style={{ marginTop: '50px', zIndex: '1' }}>
        <div id="kt_slider_tuition"></div>
      </div>
    </div>
  );
};

export { Tuition };

const TuitionDesktop = ({ tuitionMin, tuitionMax, setTuitionMin, setTuitionMax, setTuitionParams, resetStateToggle }) => {

  const location = useLocation();
  const tuitionSliderRef: any = useRef(null);
  const isFirstRender = useRef(true)

  useEffect(() => {
    if (tuitionSliderRef.current && tuitionSliderRef.current.noUiSlider) {
      tuitionSliderRef.current.noUiSlider.set([tuitionMin, tuitionMax]);
    }
  }, [tuitionMin, tuitionMax]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    setTuitionMin(sliderMinValue);
    setTuitionMax(sliderMaxValue);

    if (tuitionSliderRef.current && tuitionSliderRef.current.noUiSlider) {
      tuitionSliderRef.current.noUiSlider.set([sliderMinValue, sliderMaxValue]);
    }
  }, [resetStateToggle]);

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let tuitionParam = params.get('tuition');

    if (tuitionParam) {
      const tuitionVals = tuitionParam.split(',').map(tuition => parseInt(tuition));
      setTuitionMin(tuitionVals[0]);
      setTuitionMax(tuitionVals[1]);
    } else {
      setTuitionMin(sliderMinValue);
      setTuitionMax(sliderMaxValue);
    }
  }, [location.search, setTuitionMin, setTuitionMax]);

  useEffect(() => {
    let params = new URLSearchParams(location.search);
    let minMaxArr: any = [];

    if (tuitionMin !== sliderMinValue || tuitionMax !== sliderMaxValue) {
      minMaxArr = [tuitionMin, tuitionMax];
      const minMax = minMaxArr.join(',');
      params.set('tuition', minMax);
    } else {
      params.delete('tuition');
    }

    setTuitionParams(params.toString());
  }, [tuitionMin, tuitionMax, location.search, setTuitionParams]);

  useEffect(() => {
    const sliderElement: any = document.querySelector("#kt_slider_tuition_desktop");

    if (sliderElement && !sliderElement.noUiSlider) {

      let params = new URLSearchParams(location.search);
      let tuitionParam = params.get('tuition');
      const startValues = tuitionParam ? tuitionParam.split(',').map(tuition => parseInt(tuition)) : [sliderMinValue, sliderMaxValue];

      noUiSlider.create(sliderElement, {
        start: startValues,
        step: 500,
        range: {
          min: sliderMinValue,
          max: sliderMaxValue,
        },
        tooltips: {
          to: function (value) {
            return `$${numberConverter(parseInt(value.toFixed(0)))}`;
          },
        },
      });

      sliderElement.noUiSlider.on("set", (values, handle) => {
        if (handle === 0) {
          setTuitionMin(parseInt(values[0]));
        }
        if (handle === 1) {
          setTuitionMax(parseInt(values[1]));
        }
      });

      tuitionSliderRef.current = sliderElement;
    }

    return () => {
      if (sliderElement && sliderElement.noUiSlider) {
        sliderElement.noUiSlider.destroy();
      }
    };
  }, [location.search, setTuitionMin, setTuitionMax]);

  return (
    <div className='mt-4 d-flex flex-column' style={{ marginTop: '15px' }}>
      <div className='dca-aside-header'>TUITION</div>
      <div className="mb-0" id='dca-college-search-tuition-mobile' style={{ marginTop: '50px', zIndex: '1' }}>
        <div id="kt_slider_tuition_desktop"></div>
      </div>
    </div>
  );
};

export { TuitionDesktop };